import { render, staticRenderFns } from "./AddDomainToBlacklistModal.vue?vue&type=template&id=c17b540c"
import script from "./AddDomainToBlacklistModal.vue?vue&type=script&lang=js"
export * from "./AddDomainToBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports